import { Pipe, PipeTransform } from '@angular/core';
import { Announcement } from '../../../../shared/models/announcement';
import { AnnouncementStatus } from '../../../../shared/enums/announcement-status.enum';

@Pipe({
  name: 'isAnnouncementDeleteAvailable',
  standalone: true,
})
export class IsAnnouncementDeleteAvailablePipe implements PipeTransform {
  transform(announcement: Announcement | null | undefined): boolean {
    return announcement?.status === AnnouncementStatus.ROBOCZY;
  }
}
